import * as req from 'api/actions';
import * as c from './constant';

export const getPenaltyComputationList = (payload, callback) =>
  req.item(
    c.GET_PENALTY_COMPUTATION_LIST,
    '/api/v1/bpls/administrator/settings/penalty_computations',
    payload,
    callback
  );

export const getDiscountPenaltyList = (payload, callback) =>
  req.item(
    c.GET_DISCOUNT_PENALTY_LIST,
    '/api/v1/bpls/administrator/settings',
    payload,
    callback
  );

export const updateDiscountPenalty = (payload, callback) =>
  req.create(
    c.UPDATE_DISCOUNT_PENALTY,
    `/api/v1/bpls/administrator/settings`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );


export const getFeeCodes = (payload, callback) => 
req.list(
  c.GET_FEE_CODES,
  '/api/v1/bpls/administrator/common/fee_codes',
  payload,
  callback,
)

export const getFeeSettings = (payload, callback) => 
req.list(
  c.GET_FEE_SETTINGS,
  '/api/v1/bpls/administrator/fee_settings',
  payload,
  callback,
)

export const updateFeeSettings = (payload, callback) => 
  req.create(
    c.UPDATE_FEE_SETTINGS,
    '/api/v1/bpls/administrator/fee_settings',
    payload,
    callback,
  );

export const getRevokedPermitReapplicationOptionList = (payload, callback) => 
  req.list(
    c.GET_REVOKED_PERMIT_REAPPLICATION_OPTION_LIST,
    '/api/v1/bpls/administrator/settings/revoked_permit_reapplication_options',
    payload,
    callback,
  )

export const getRetireDelinquentBusinessOptionList = (payload, callback) =>
  req.list(
    c.GET_RETIRE_DELINQUENT_BUSINESS_OPTION_LIST,
    '/api/v1/bpls/administrator/settings/retire_delinquent_business_options',
    payload,
    callback
  );

export const getPenaltyDisplayInOr = (payload, callback) => 
  req.list(
    c.GET_PENALTY_DISPLAY_IN_OR,
    '/api/v1/bpls/administrator/settings/penalty_displays_in_or',
    payload,
    callback,
  );

export const getStartInterestOption = (payload, callback) => 
  req.list(
    c.GET_START_INTEREST_OPTION,
    '/api/v1/bpls/administrator/settings/start_of_interest_options',
    payload,
    callback,
  )